<template>
  <div style="height: 100%;">
    <el-container style="height: 100%;">
      <el-header class="skill-group-content">
        <h3 class="title">
          <div class="block">
            <span>技能组管理</span>
          </div>
        </h3>
      </el-header>
      <el-container style="height: calc(100% - 70px)">
        <el-aside class="side" style="padding-bottom: 80px;">
          <div class="side-title">
            <span>
              <h5>技能组列表</h5>
            </span>
            <!-- TODO 导入导出 -->
          </div>
          <div class="side-content">
            <div class="search-Box">
              <el-input placeholder="请输入关键字" class="selectInput" v-model="search" size="small">
                <svg slot="suffix" class="icon" aria-hidden="true">
                  <use xlink:href="#iconsearchicon" />
                </svg>
              </el-input>
            </div>
            <el-scrollbar style="height: calc(100% - 42px);">
            <div class="table-list table-list-medium">
              <el-table
                @row-click="clickRow"
                highlight-current-row
                :data="tables"
                :show-header="hideHeader"
                ref="skillTable"
                style="width: 100%"
              >
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column fixed="right" label="操作" width="50">
                  <template slot-scope="scope">
                    <el-button
                      style="padding: 0%;"
                      @click="deleteSkill(scope.row)"
                      v-if="computeSGDel(scope.row.id)"
                      type="text"
                      size="small"
                    >
                      <svg class="icon icon-delete" aria-hidden="true">
                        <use xlink:href="#icontable-delete" />
                      </svg>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            </el-scrollbar>
          </div>
        </el-aside>
        <el-main class="section">
          <el-row type="flex" justify="end">
            <el-button
              v-if="$authUtis.hasButtonAuth('aicc-bp', '/skill/addSkillGroup_post')"
              style="margin-bottom:10px"
              icon="el-icon-plus"
              size="small"
              type="info"
              @click="addSkillGroup = true"
            >添加技能组</el-button>
          </el-row>
          <el-scrollbar style="height: calc(100% - 122px);">
          <el-tabs class="tabs" stretch type="card" v-model="tabActiveName">
            <el-tab-pane label="技能组成员" name="skillGroupMember">
              <MemberTable />
            </el-tab-pane>
            <el-tab-pane label="技能组设置" name="skillGroupSetting">
              <SkillSetting />
            </el-tab-pane>
          </el-tabs>
          </el-scrollbar>
        </el-main>
        <!-- 添加技能组 -->
        <el-dialog
          title="添加技能组"
          width="480px"
          :destroy-on-close="true"
          :visible.sync="addSkillGroup"
        >
          <el-row>
            <div>
              <el-form :inline="true">
                <el-form-item label="技能组名:">
                  <el-input
                    v-model="addSkillGroupName"
                    maxlength="8"
                    placeholder="技能组名称最大长度8个字"
                    style="width:340px;"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <el-row type="flex" justify="center">
              <el-button size="medium" @click="addSkillGroup = false">取 消</el-button>
              <el-button size="medium" type="primary" @click="addSkillGroupFn">确 定</el-button>
            </el-row>
          </el-row>
        </el-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import MemberTable from './MemberTable'
import SkillSetting from './SkillSetting'
import { mapActions } from 'vuex'
import { addSkillGroup, deleteSkillGroup } from '@/api/user'
export default {
  name: '',
  data() {
    return {
      tabActiveName: 'skillGroupMember',
      addSkillGroupName: '',
      addSkillGroup: false,
      hideHeader: false,
      search: '',
      curClkRow: null
    }
  },
  watch: {
    tables: function() {
      this.$nextTick(() => {
        this.setClickRow()
      })
    }
  },
  components: {
    MemberTable,
    SkillSetting
  },
  computed: {
    tables: function() {
      var search = this.search
      if (search) {
        return this.storeSkillGroupList.filter(function(dataNews) {
          return Object.keys(dataNews).some(function(key) {
            return key === 'name' && String(dataNews[key]).indexOf(search) > -1
          })
        })
      }
      return this.storeSkillGroupList
    },
    // TODO  改成vuex  map 获取
    storeSkillGroupList() {
      return this.$store.state.user.skillGroupList
    },
    storeDegaultSGId() {
      return this.$store.state.skill.defaultSkillGroupId
    }
  },
  mounted() {
    this._listSkillGroup()
    this._getUserGroupTree({ type: '1' }) // 加载坐席组(带成员)
    this.clickRow({ id: this.storeDegaultSGId })
  },
  methods: {
    ...mapActions('user', ['_listSkillGroup', '_getUserGroupTree']),
    computeSGDel(rowId) {
      return (
        rowId !== this.storeDegaultSGId &&
        this.$authUtis.hasButtonAuth('aicc-bp', '/skill/deleteSkillGroup_delete')
      )
    },
    setClickRow() {
      const me = this
      const clkrows = this.storeSkillGroupList.filter(dataNews => {
        return Object.keys(dataNews).some(key => {
          return String(dataNews[key]) === (me.curClkRow ? me.curClkRow.id : me.storeDegaultSGId)
        })
      })
      if (clkrows.length > 0) {
        this.$refs.skillTable.setCurrentRow(clkrows[0])
      }
    },
    addSkillGroupFn() {
      if (this.addSkillGroupName) {
        addSkillGroup(this.addSkillGroupName)
          .then(res => {
            if (res.code === 2000) {
              this.$message.success(res.data)
              this._listSkillGroup()
              this.addSkillGroup = false
              this.addSkillGroupName = ''
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      } else {
        this.$message.error('添加技能组填写有误')
      }
    },
    clickRow(row) {
      this.tabActiveName = 'skillGroupMember'
      this.$store.commit('user/setClickSkillGroupId', { id: row.id })
      this.curClkRow = row
    },
    deleteSkill(row) {
      this.$confirm('是否删除此技能组？', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false
      })
        .then(() => {
          deleteSkillGroup(row.id)
            .then(res => {
              if (res.code === 2000) {
                this.$message.success(res.data)
                this._listSkillGroup()
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(err => {
              this.$message.error(err)
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.el-aside {
  &.side {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
    .side-title {
      flex: 0 0 40px;
    }

    .side-content {
      display: flex;
      flex-direction: column;
      /*flex: 1;*/
      flex: 1 0 auto;
      height: calc(100% - 50px);
      .table-list {
        flex: 1;
        /*overflow-y: auto;*/
        .el-table {
          tr {
            &.hover-row {
              td{
                .icon-delete {
                  color: #f66f6a;
                }
              }
            }
          }
        }
      }
    }
  }
}
.zxtitle {
  background-color: rgba(215, 215, 215, 1);
  line-height: 40px;
}
.el-tabs >>> .is-active {
  color: #409eff;
}
.tabs {
  height: auto;
  /*overflow: auto;*/
  /*height: calc(100% - 42px);*/
}

.selectInput {
  box-sizing: border-box;
  margin-bottom: 10px;
}

.skill-group-content {
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  .title {
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.table-list {
  &.table-list-medium {
    td {
      height: 40px !important;
      line-height: 40px !important;
    }
  }
  .el-table {
    &:before {
      background-color: transparent;
    }
    .el-table__fixed-right {
      &:before {
        background-color: transparent;
      }
    }
    .el-table__fixed {
      &:before {
        background-color: transparent;
      }
    }

    tr {
      &.current-row {
        td {
          background-color: #edeef0;
          color: #337eff;
          border-color: transparent;
          .icon {
            color: #337eff;
          }
        }
      }

      &.hover-row {
        cursor: pointer;

        td {
          background-color: transparent;
          color: #337eff;
          border-color: transparent;
          .icon {
            color: #337eff;
          }
        }
      }

      td {
        border-bottom: none;
        height: 40px;
        line-height: 40px;
        padding-top: 0;
        padding-bottom: 0;
        color: #555;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        .cell {
          height: 23px;
        }
      }
    }
  }
}
.el-tabs__content {
  height: auto;
}
.el-table:before{
  background: #fff !important;
}
</style>
